import { fromJS, List } from 'immutable';
import { handleActions } from 'redux-actions';

import { SET_STOCKS } from './constants';

const initialState = fromJS({
	stockItems: [],
});

export default handleActions({
	[SET_STOCKS]: (state: any, { payload }: any) => state.updateIn(['stockItems'], () => List(payload.param.map((item: any) => item))),
}, initialState);
